module.exports = __webpack_public_path__ + "img/menu-closed.7ee081a1.svg";